import { Styles } from "@mcleod/core";

export const PanelStyles = Styles.make("pnl", () => {
    return {
        panelRow: {
            display: "flex",
            flexDirection: "row",
            scrollBehavior: "smooth",
            alignItems: "center"
        },
        panel: {
            display: "flex",
            flexDirection: "column"
        },
        noSelect: {
            WebkitTouchCallout: "none",
            WebkitUserSelect: "none",
            KhtmlUserSelect: "none",
            MozUserSelect: "none",
            MsUserSelect: "none",
            userSelect: "none"
        },
        rowFillHeight: {
            flex: "1",
            overflow: "hidden",
            alignItems: "unset"
        },
        hideScroll: {
            MsOverflowStyle: "none",
            scrollbarWidth: "none",
            overflow: "hidden"
        },
        slimScrollbar: {
            "&::-webkit-scrollbar": {
                width: "6px",
                height: "6px"
            },
            "&::-webkit-scrollbar-track": {
                backgroundColor: "#f0f0f0",
                borderRadius: "3px"
            },
            "&::-webkit-scrollbar-thumb": {
                backgroundColor: "#aaa",
                borderRadius: "3px",
                backgroundClip: "padding-box"
            },
            "&::-webkit-scrollbar-button": {
                display: "none"
            },
            "&::-webkit-scrollbar-corner": {
                backgroundColor: "#f0f0f0"
            },
            "&::-webkit-scrollbar-resizer": {
                display: "none"
            }
        }
    }
});
